import React, { useRef, useState, useEffect } from 'react';
import { Tabs,Modal, message, Spin } from 'antd';
import { modalAddPlanFn } from './addPlan';
import AddContract from './addContract';
import {useParams} from 'react-router-dom'
type TargetKey = React.MouseEvent | React.KeyboardEvent | string;
import { receiptRulesPlanMainRulesPlanDetail, receiptRulesPlanRulesBranchPlanDelete} from '@/services/fmsConfig'
const { confirm } = Modal;

interface Props {
  onDataChange?: (hasChanges?: boolean) => void;
}

export default ({ onDataChange }: Props) => {
    // const initialItems = [
    //     { label: '主合同', children: (<AddContract />), key: '1', closable: false, },
    //     { label: '重签差额', children: (<AddContract />), key: '2', closable: false, },
    //     {
    //         label: '补充合同',
    //         children: (<AddContract />),
    //         key: '3',
    //     },
    // ];
    // const [initialItems, setInitialItems] = useState([] as any);
    const [activeKey, setActiveKey] = useState('');
    const [items, setItems] = useState([] as any);
    const [loading, setLoading] = useState(false);
    const { id } = useParams()
    useEffect(() => {
        getRulesPlanDetail()
    }, []);
    const getRulesPlanDetail = (type='no') =>{
        setLoading(true)
        receiptRulesPlanMainRulesPlanDetail({
            rulesPlanMainId: id,
            isFull: false,
        }).then((res)=>{
            if(res?.rulesBranchPlanVo && res.rulesBranchPlanVo.length !== 0){
                res.rulesBranchPlanVo.map((item) => {
                    item.label = item.planTypeName;
                    item.key = item.id
                    item.children = renderAddContract(item)
                })
                setItems(res.rulesBranchPlanVo)
                if(type === 'no'||type === 'remove'){
                    setActiveKey(res.rulesBranchPlanVo[0].key)
                }
                if(type === 'add'){
                    setActiveKey(res.rulesBranchPlanVo[res.rulesBranchPlanVo.length-1].key)
                }
            } else {
                setItems([])
                setActiveKey('')
            }
            setLoading(false)
        }).catch(err=>{
            setLoading(false)
        })
    }
    const onChange = (newActiveKey: string) => {
        setActiveKey(newActiveKey);
        getRulesPlanDetail('edit');
        onDataChange?.(true);
    };

    const add = () => {
        modalAddPlanFn({
            fn: () => {
                getRulesPlanDetail('add');
                onDataChange?.(true);
            },
            ...{planMainId: id}
        });
    };

    const remove = (targetKey: TargetKey) => {
        confirm({
            title: '确认删除?',
            okText: '删除',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                receiptRulesPlanRulesBranchPlanDelete(targetKey).then((res:any)=>{
                    getRulesPlanDetail('remove')
                    message.success(res.message || '删除成功')
                    onDataChange?.(false);
                })
            },
            onCancel() {
              console.log('Cancel');
            },
          });
    };

    const onEdit = (
        targetKey: React.MouseEvent | React.KeyboardEvent | string,
        action: 'add' | 'remove' | 'edit',
    ) => {
        if (action === 'add') {
            add();
        } else {
            remove(targetKey);
        }
    };

    const renderAddContract = (item: any) => {
        return (
            <AddContract 
                rest={item} 
                onDataChange={onDataChange}
            />
        );
    };

    return (
        <div style={{ padding: '15px 0px' }}>
            <Spin spinning={loading}>
                <Tabs
                    type="editable-card"
                    onChange={onChange}
                    activeKey={activeKey}
                    onEdit={onEdit}
                    items={items}
                />
            </Spin>
        </div>

    );
};